import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('IDX_356adebd2b471231ba317ccbf2', ['name', 'version'], { unique: true })
@Index('IDX_b87259af3071d44f307529b029', ['name', 'isActive'], {})
@Entity('_vault_keys')
export class VaultKeysEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('text', { name: 'key_data' })
	public keyData!: string;

	@Column('int', { name: 'version', default: () => "'1'" })
	public version!: number;

	@Column('varchar', {
		name: 'algorithm',
		length: 50,
		default: () => "'aes-256-cbc'",
	})
	public algorithm!: string;

	@Column('tinyint', { name: 'is_active', default: () => "'1'" })
	public isActive!: number;

	@Column('timestamp', { name: 'expires_at', nullable: true })
	public expiresAt!: Date | null;
}
